import NavBar from './components/NavBar'; 
import Landing from './components/Landing'; 
import Skills from './components/Skills'; 
import About from './components/About'; 
import Footer from './components/Footer';
import Gallerie from './components/Gallerie';
import Projects from './components/Projects'; 
import Appearances from './components/Appearances'; 
import Awards from './components/Awards';  
import Resume from './components/Resume'; 
import './App.css'; 

function App() {
  return (
    <div className="portfolioBody">
       <NavBar />
       <Landing />
       <About />
       <Skills />
       <Awards />
       <Appearances />
       <Projects />
       <Gallerie />
       <Resume />
       <Footer />
    </div>
  );
}

export default App;
